import { INode } from '@cbridge-packages/node';
import { INavigationBlockItemBase } from '@cbridge-tools/navigation-block';
import { generateClientSymbolsRoute } from '@cbridge-packages/routing-client-admin';

export const nodeAsClientSymbolNavigationItem = (node: INode): INavigationBlockItemBase => ({
  value: node.nodeId,
  label: node.name,
  href: generateClientSymbolsRoute(node.nodeId),
});
